module.exports = __webpack_public_path__ + "img/padding.2e12465.png";